import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 用户管理：用户列表
 * @param vCom Vue组件
 */
const GetUsersList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/users", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 用户管理：所属机构搜索
 * @param vCom Vue组件
 */
const SearchHospitalsList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/search/center/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 用户管理：数据中心搜索
 * @param vCom Vue组件
 */
const SearchCentersList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/search/centers", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 新建/编辑用户
 * @param vCom Vue组件
 */
const SaveUser = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/user", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 用户管理：重置密码
 * @param vCom Vue组件
 */
const ResetUserPassword = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/reset/password", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 用户管理：禁用/启用
 * @param vCom Vue组件
 */
const ChangeUserState = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/ban/user", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 机构管理：机构列表页
 * @param vCom Vue组件
 */
const GetHospitalList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 新增/编辑机构
 * @param vCom Vue组件
 */
const SaveHospital = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 机构详情
 * @param vCom Vue组件
 */
const GetHospitalDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/admin/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除机构
 * @param vCom Vue组件
 */
const DeleteHospital = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/admin/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 子产品列表
 * @param vCom Vue组件
 */
const GetProductList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/products", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 子产品列表
 * @param vCom Vue组件
 */
const PostProductDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/product", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除子产品
 * @param vCom Vue组件
 */
const DeleteProduct = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/product", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 子产品详情
 * @param vCom Vue组件
 */
const GetProductDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/product", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 子产品搜索列表页
 * @param vCom Vue组件
 */
const SearchProductList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/admin/search/products", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

export {
    GetUsersList, SearchHospitalsList, SearchCentersList, SaveUser, ResetUserPassword, ChangeUserState,
    GetHospitalList, SaveHospital, GetHospitalDetail, DeleteHospital,
    GetProductList, PostProductDetail, DeleteProduct, GetProductDetail, SearchProductList
};
